import { render } from "./UiLoader.vue?vue&type=template&id=93c03c5e"
const script = {}

import "./UiLoader.vue?vue&type=style&index=0&id=93c03c5e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__